/**
 * Which native shell, if any, is hosting the webapp.
 *
 * The Android app appends `BeoflowAndroid/<version>` to its WebView User-Agent
 * (`ANDROID_APP_UA_MARKER` in beoflow-android `ui/web/WebShell.kt`). Changing either string
 * without the other silently breaks the Play-billing guard below.
 */
export function isAndroidApp(): boolean {
  return typeof navigator !== 'undefined' && / BeoflowAndroid\//.test(navigator.userAgent)
}

/**
 * The shipped iOS shells use one of these markers:
 * - the main web shell: `beoflow_mobile_app BeoflowApp iOSWebView`
 * - the integrations shell: `BeoflowApp iOS IntegrationsWebViewV2`
 *
 * Unlike the auth handoff flag, a UA marker survives logout followed by
 * web-form login, so Stripe controls cannot reappear inside the app.
 */
export function isIOSApp(): boolean {
  if (typeof navigator === 'undefined') return false
  return (
    /(?:^|\s)beoflow_mobile_app(?:\s|$)/i.test(navigator.userAgent) ||
    /(?:^|\s)BeoflowApp\s+iOS(?:WebView|\s+IntegrationsWebViewV2)(?:\s|$)/.test(
      navigator.userAgent,
    )
  )
}

/**
 * True when we must not offer to sell a digital subscription.
 *
 * Google Play requires digital subscriptions consumed in the app to go through Play Billing,
 * so an Android WebView may not route the user to our own Stripe checkout or portal. v1
 * decision (2026-07-30): Android shows subscription STATUS only.
 */
export function purchasesBlocked(): boolean {
  return isAndroidApp() || isIOSApp()
}
